import { FC, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { OrderReviewDto } from '../../dtos';
import { ApiError, LoadingIndicator, useFailedUpdateSnackbar, useSuccessfulUpdateSnackbar } from '../../Components/CoreLib/library';
import { useGetOrderReviewByIdQuery, useUpdateOrderReviewMutation } from '../../store/generated/generatedApi';
import { OrderReviewForm } from '../../Components/Forms/OrderReviewForm';
import { toEasternDateKey } from '../../util';

export const EditOrderReviewView: FC = () => {
    const { orderId, jobId, orderReviewId } = useParams();
    const navigate = useNavigate();
    const { data, isLoading, isFetching, error, refetch } = useGetOrderReviewByIdQuery({ id: orderReviewId! });
    const [updateOrderReview, { isSuccess, isError, isLoading: updating, reset, error: updateError }] = useUpdateOrderReviewMutation();

    useSuccessfulUpdateSnackbar('Order Review', isSuccess, () => {
    });
    useFailedUpdateSnackbar('order Review', isError, reset, updateError);

    const handleSave = useCallback((values: OrderReviewDto) => {
        updateOrderReview(values).then(() => {
            refetch();
        }).catch((error) => {
            console.error(error);
        });
    }, [updateOrderReview, refetch]);

    const handleCancel = useCallback(() => {
        if (data) {
            navigate(`/orderReview?date=${toEasternDateKey(data.orderDate)}& view=${data.readyForBilling ? 'BILLING' : 'CUSTOMER-SERVICE'} `);
        }
    }, [data, navigate]);

    const renderForm = useCallback(() => {
        return <OrderReviewForm save={handleSave} cancel={handleCancel} initValues={data} jobId={jobId ?? ''} orderId={orderId ?? ''} isLoading={updating || isFetching} />;
    }, [data, handleSave, handleCancel, updating, isFetching, jobId, orderId]);
    
    if (isLoading) {
        return <LoadingIndicator />;
    }

    if (error) {
        return <ApiError onReloadClick={refetch} />;
    }


    return renderForm();
};
